export type TemplateEditorMode = 'visual' | 'html' | 'design' | 'preview'

// Keep the unfinished controls available for a later iteration without exposing them to dispatchers.
export const DESIGN_EDITOR_ENABLED: boolean = false

export const TEMPLATE_EDITOR_MODES = [
    { key: 'visual', label: 'Visual' },
    { key: 'html', label: 'HTML' },
    { key: 'design', label: 'Design' },
    { key: 'preview', label: 'Preview' },
]
